import { useLayoutEffect, useRef, useState } from "react";

export const useCaptionOverflow = (opts: { enabled: boolean; text?: string; isExpanded: boolean }) => {
    const { enabled, text, isExpanded } = opts
    const ref = useRef<HTMLDivElement | null>(null)
    const [isOverflowing, setIsOverflowing] = useState(false)

    useLayoutEffect(() => {
        if (!enabled || !text) {
            setIsOverflowing(false)
            return
        }

        const el = ref.current
        if (!el) return

        if (isExpanded) return

        const measure = () => {
            setIsOverflowing(el.scrollHeight - el.clientHeight > 1)
        }

        measure()

        let ro: ResizeObserver | null = null
        if (typeof ResizeObserver !== 'undefined') {
            ro = new ResizeObserver(() => measure())
            ro.observe(el)
        } else {
            window.addEventListener('resize', measure)
        }

        return () => {
            ro?.disconnect()
            window.removeEventListener('resize', measure)
        }
    }, [enabled, text, isExpanded])

    return { ref, isOverflowing }
}